import { literal, number, object, type InferOutput } from "valibot"
import { StorageKind } from "../StorageKind/StorageKind.enum"

export const StoredItemMetaLocalStorageSchema = object({
  kind: literal(StorageKind.LocalStorage),
  // refers to the value in `input_profile_${id}` in the user's browser
  id: number(),
})

export type StoredItemMetaLocalStorage = InferOutput<typeof StoredItemMetaLocalStorageSchema>
